import index from './index.vue';
import { FormData } from './all.type';

export default index;
export {
    FormData
};